import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import MUIDialog from '@material-ui/core/Dialog';
import MUIDialogTitle from '@material-ui/core/DialogTitle';
import MUIDialogContent from '@material-ui/core/DialogContent';
import MUIDialogActions from '@material-ui/core/DialogActions';

import CloseButton from 'WeployDesignLanguage/buttons/CloseButton';

const MUIDialogWrapper = styled(MUIDialog)`
  position: relative;

  & .MuiPaper-root {
    border-radius: ${props => props.theme.borderRadius};
    padding: ${props => props.theme.spacing[3]} ${props => props.theme.spacing[2]} ${props => props.theme.spacing[2]};
    width: ${props => (props.fullScreen ? null : props.width)};
  }

  & .MuiPaper-rounded {
    border-radius: ${props => props.theme.borderRadius.large}
  }
`;

const MUIDialogTitleWrapper = styled(MUIDialogTitle)`
  padding: 0 ${props => props.theme.spacing[1]};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const MUIDialogContentWrapper = styled(MUIDialogContent)`
  padding-left: ${props => props.theme.spacing[1]};
  padding-right: ${props => props.theme.spacing[1]};
`;

const MUIDialogActionsWrapper = styled(MUIDialogActions)`
  padding: 0;
`;

const Dialog = ({
  onClose,
  open,
  children,
  width,
  fullScreen,
}) => (
  <MUIDialogWrapper open={open} onClose={onClose} width={width} fullScreen={fullScreen} >
    {children}
  </MUIDialogWrapper>
);

Dialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  width: PropTypes.string,
  fullScreen: PropTypes.bool,
};

Dialog.defaultProps = {
  width: '600px',
  fullScreen: false,
};

const Title = ({ children, onClose }) => (
  <MUIDialogTitleWrapper disableTypography>
    <h6>{children}</h6>
    <CloseButton onClick={onClose} />
  </MUIDialogTitleWrapper>
);

Title.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
};

const Content = ({ children }) => (
  <MUIDialogContentWrapper>{children}</MUIDialogContentWrapper>
);

Content.propTypes = {
  children: PropTypes.node.isRequired,
};

const Actions = ({ children }) => (
  <MUIDialogActionsWrapper>{children}</MUIDialogActionsWrapper>
);

Actions.propTypes = {
  children: PropTypes.node.isRequired,
};

Dialog.Title = Title;
Dialog.Content = Content;
Dialog.Actions = Actions;


export default Dialog;
